// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dS-V","title":"styles_title__2GipN"};